/**
 * QuotedPreview — bloco compacto de citação (reply_to).
 *
 * Exibe uma barra vertical teal + nome do autor + trecho da mensagem citada.
 * Ao clicar, rola a página até o balão original.
 */
import { Box, Text } from '@mantine/core'
import type { ChatMessageReplyTo } from '@/api/chat'

interface Props {
  replyTo: ChatMessageReplyTo
}

export function QuotedPreview({ replyTo }: Props) {
  function handleClick() {
    const el = document.getElementById(`msg-${replyTo.id}`)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  const displayAuthor = replyTo.author_name ?? replyTo.kind

  return (
    <Box
      mb={6}
      px={8}
      py={4}
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        borderLeft: '3px solid var(--mantine-color-teal-5, #0ba5ab)',
        background: 'var(--ai-bg-subtle)',
        borderRadius: 4,
        userSelect: 'none',
      }}
    >
      <Text size="xs" fw={600} c="teal.7" lineClamp={1}>
        {displayAuthor}
      </Text>
      <Text size="xs" c="dimmed" lineClamp={2} style={{ wordBreak: 'break-word' }}>
        {replyTo.snippet}
      </Text>
    </Box>
  )
}
